import { Organico } from './../../../services/organico-interrogator.service';
import { PraticaElement } from './../../../components/back-office/ricerca-pratica/ricerca-pratica.component';
import { Component, OnInit, Inject, } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { OrganicoInterrogatorService } from 'src/app/services/organico-interrogator.service';

@Component({
  selector: 'app-search-intestatario-modal',
  templateUrl: './search-intestatario-modal.component.html',
  styleUrls: ['./search-intestatario-modal.component.scss']
})
export class SearchIntestatarioModalComponent implements OnInit {

  public searchIntestatarioFormComponent: FormGroup = this.formBuilder.group({
    cognome: [null, [Validators.maxLength(60)]],
    nome: [null, [Validators.maxLength(60)]],
    codiceFiscale: [null, [Validators.maxLength(16)]],
  });

  public intestatari: FormControl = new FormControl(null, Validators.required);

  public showTable = false;
  public showNoResults = false;
  public showPartitaIva = false;
  public isRealPerson = true;
  public gender = false;
  public showName = true;
  datasource = [];
  displayedColumns: string[] = ['cognome', 'nome', 'codice fiscale / partita iva', ' '];
  public intesLoaded = [];
  /*  {
      key: 'cognomeDenominazione',
      fallBackKey: 'denominazione',
      value: 'APPLICATION.BACK_OFFICE.BASE_TABLE_UTENTE.COGNOME'
    },
    {
      key: 'nome',
      fallBackKey: 'nome',
      value: 'APPLICATION.BACK_OFFICE.BASE_TABLE_UTENTE.NOME'
    },
    {
      key: 'codiceFiscale',
      fallBackKey: 'codiceFiscale',
      value: 'APPLICATION.BACK_OFFICE.BASE_TABLE_UTENTE.CODICE_FISCALE'
    }
  ];*/

  ngOnInit() {}

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SearchIntestatarioModalComponent>,
    private organicoInterrogatorService: OrganicoInterrogatorService,
    @Inject(MAT_DIALOG_DATA) public data: { header: string, isPersonaFisica: boolean, text: string, modalParam: any}) {
  }

  getColumns() {
    return this.displayedColumns;
  }

  loadIntestatarioData(index) {
    this.dialogRef.close(this.intesLoaded[index]);
  }

  searchIntestatario() {
    const organicoIntestatario: Organico = this.searchIntestatarioFormComponent.getRawValue();
    this.organicoInterrogatorService.findIntestatari(organicoIntestatario).toPromise().then( response => {
      this.datasource = response.content.filter((intestatario => this.data.isPersonaFisica ? intestatario.personaFisica === true : intestatario.personaFisica === false)).map((intes) => {
        return {
          cognome: intes.cognomeDenominazione,
          nome: intes.nome,
          'codice fiscale / partita iva': this.data.isPersonaFisica ? intes.codiceFiscale : intes.partitaIva,
          ' ': 'loadData'
        };
      });
      this.showTable = this.datasource.length > 0;
      this.showNoResults = this.datasource.length === 0;
      this.intesLoaded = response.content.filter((intestatario => this.data.isPersonaFisica ? intestatario.personaFisica === true : intestatario.personaFisica === false));
    });
  }

}
